import { Zone } from '@/models/location';
// import { ReturnType } from './types';
import { Feature, FeatureCollection, Geometry } from 'geojson';
import { getPolygonColor } from './helpers';
import { useMemo } from 'react';

export const useGeoJson = ({
  zones,
  disabled,
}: {
  zones?: Zone[];
  disabled?: boolean;
}) => {
  const geojson = useMemo(
    () => (zones ? mapToGeoJson({ zones, disabled: !!disabled }) : null),
    [zones, disabled]
  );

  return {
    geojson,
  };
};

export type ReturnType = {
  type: 'FeatureCollection';
  features: Feature<Geometry>[];
};

const mapToGeoJson = ({
  zones,
  disabled = false,
}: {
  zones: Zone[];
  disabled: boolean;
}): FeatureCollection => {
  const max = Math.max(...zones.map((o) => o.stats?.visits || 0));

  const features = zones.reduce((acc: Feature<Geometry>[], el: Zone) => {
    const isDisabled = el.area.disabled || disabled;

    const feature: Feature<Geometry> = {
      type: 'Feature',
      properties: {
        id: el.id,
        color: getPolygonColor({
          current: el.stats && el.stats.visits,
          max,
          disabled: isDisabled,
        }),
        opacity: 0.3,
        disabled: isDisabled,
      },
      geometry: {
        type: 'Polygon',
        coordinates: JSON.parse(el.polygon),
      },
    };
    acc.push(feature);

    return acc;
  }, []);

  return {
    type: 'FeatureCollection',
    features,
  };
};
